import React from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmAbortModal } from "@ts-digital/vrc";
import FeedbackAskImg from "../../../../assets/img/ask-doc-feedback.svg";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import useChangeCompany from "../../../../customHooks/useChangeCompany";

const Feedback = props => {
  const navigate = useNavigate();
  const { docs, onClose } = props;
  const {changeCompanySelected} = useChangeCompany();

  const answer = useSelector(state => state.ask.answer.detail);
  const companies = useSelector(state => state.company.companies);

  let title = useIntl().formatMessage({ id: (docs && docs.length > 1) ?  "ask.feedback.docsTitle" : "ask.feedback.docTitle" });

  const abortText = useIntl().formatMessage({ id: "actions.close" });
  const confirmText = useIntl().formatMessage({ id: "actions.goDocuments" });
  const docsDescription = useIntl().formatMessage({ id: "ask.feedback.docsDescription" });
  const docDescription1 = useIntl().formatMessage({ id: "ask.feedback.docDescription1" });
  const docDescription2 = useIntl().formatMessage({ id: "ask.feedback.docDescription2" });
  const docHint = useIntl().formatMessage({ id: "ask.feedback.docHint" });

  return (
    <ConfirmAbortModal
      visible={true}
      title={title}
      onClose={onClose}
      type="primary"
      outsideClosable={false}
      onAbort={onClose}
      onConfirm={() => {
        changeCompanySelected(companies.find(x => x.uuid === answer.itemId).id);
        navigate("/documenti", { state: { macro: "Inbox"} });       
      }}
      abortText={abortText}
      confirmText={confirmText}
    >
      <div className="askAnswer-doc-feedback-dialog">
        <div className="feedback-image">
          <img src={FeedbackAskImg} alt="" />
        </div>
        <div className="feedback-description">
          {docs && docs.length > 1 ? (
            docsDescription
          ) : (
            <span>
              {docDescription1}{" "}
              <strong>
                {(docs && docs[0] && docs[0].fileName) || "NoFilename"}
              </strong>
              <br />
              {docDescription2}
            </span>
          )}
        </div>
        <div className="feedback-hint">
          {docHint}
          <strong> InBox.</strong>
        </div>
      </div>
    </ConfirmAbortModal>
  );
};

export default Feedback;
